'use client';

import React from 'react';
import HeroSection from './HeroSection';
import ImpactStatsSection from './ImpactStatsSection';
import ProjectMapSection from './ProjectMapSection';
import DonationPortalSection from './DonationPortalSection';
import BeneficiaryStoriesSection from './BeneficiaryStoriesSection';
import TransparencySection from './TransparencySection';
import VolunteerSection from './VolunteerSection';
import EmergencyResponseSection from './EmergencyResponseSection';
import CTASection from './CTASection';

const HumanitarianActionInteractive = () => {
  return (
    <>
      <HeroSection />
      <ImpactStatsSection />
      <ProjectMapSection />
      <DonationPortalSection />
      <BeneficiaryStoriesSection />
      <TransparencySection />
      <VolunteerSection />
      <EmergencyResponseSection />
      <CTASection />
    </>
  );
};

export default HumanitarianActionInteractive;